import { CreateFocusCss } from '../../../styles'
import type { Tokens } from '../../../theming/types'
import { styles } from '../../../utilities'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        minHeight: tokens.selectionControl.size,
        minWidth: tokens.selectionControl.size,
        position: 'relative',
      },

      input: {
        ...styles.visuallyHidden,
        ...CreateFocusCss(
          tokens.focusOuter,
          (psuedoClass) => `${psuedoClass} + label .focusStyles`,
        ),
      },

      description: {
        marginBlock: '6px 0',
        marginInline: '30px 0',
      },

      error: {
        marginBlock: '6px 0',
        marginInline: '30px 0',
      },

      label: {
        alignItems: 'flex-start',
        display: 'inline-flex',
        color: tokens.fontColorDefault,
        minHeight: tokens.selectionControl.size,
        minWidth: tokens.selectionControl.size,

        '&:hover': {
          cursor: 'pointer',
        },

        'input:disabled + &': {
          cursor: 'not-allowed',
        },
      },

      radioButtonBorder: {
        backgroundColor: tokens.formControlBgColorDefault,
        border: `1px solid ${tokens.formControlBorderColorDefault}`,
        borderRadius: '50%',
        content: '""',
        cursor: 'pointer',
        display: 'flex',
        flex: '0 0 auto',
        height: tokens.selectionControl.size,
        position: 'relative',
        width: tokens.selectionControl.size,
      },

      radioButtonFill: {
        alignSelf: 'center',
        background: tokens.selectionControl.selectedHoverFillColor,
        border: `5px solid ${tokens.selectionControl.selectedHoverFillColor}`,
        borderRadius: '50%',
        content: '""',
        pointerEvents: 'none',
        display: 'block',
        marginInlineStart: '3px',
      },

      labelText: {
        ...tokens.fontBodyM,
        minHeight: tokens.selectionControl.size,
        paddingInlineStart: '12px',
      },
    },

    disabled: {
      label: {
        opacity: tokens.form.disabledOpacity,
      },

      radioButtonHover: {
        cursor: 'not-allowed',
      },

      radioButtonBorder: {
        opacity: `${tokens.form.disabledOpacity} !important`,
        cursor: 'not-allowed',
      },

      radioButtonFill: {
        cursor: 'not-allowed',
      },
    },

    invalid: {
      radioButtonBorder: {
        borderColor: `${tokens.formElementInputBorderColorError} !important`,
      },

      radioButtonFill: {
        borderColor: `${tokens.formElementInputBorderColorError} !important`,
      },
    },

    hideLabel: {
      label: styles.visuallyHidden,
    },

    motionVariants: {
      radioButtonBorder: {
        checked: {
          borderColor: tokens.formControlBgColorSelected,
          transition: { duration: 0.15 },
        },
        unchecked: {
          borderColor: tokens.formControlBorderColorDefault,
          transition: { duration: 0.15 },
        },
        hoverWhenChecked: {
          borderColor: tokens.selectionControl.selectedHoverFillColor,
          transition: { duration: 0.1 },
        },
        hoverWhenUnchecked: {
          borderColor: tokens.formControlBorderColorHover,
          transition: { duration: 0.1 },
        },
        tapWhenChecked: {
          borderColor: tokens.selectionControl.selectedActiveFillColor,
          transition: { duration: 0.15 },
        },
        tapWhenUnchecked: {
          borderColor: tokens.formControlBorderColorActive,
          transition: { duration: 0.15 },
        },
      },
      radioButtonFill: {
        checked: {
          opacity: 1,
          scale: 1,
          transition: { duration: 0.15 },
        },
        unchecked: {
          opacity: 0,
          scale: 0,
          transition: { duration: 0.15 },
        },
        hoverWhenChecked: {
          borderColor: tokens.selectionControl.selectedHoverFillColor,
          transition: { duration: 0.15 },
        },
        tapWhenChecked: {
          borderColor: tokens.selectionControl.selectedActiveFillColor,
          transition: { duration: 0.15 },
        },
      },
    },
  } as const
}
